import { auth } from "./auth";
import { enums } from "element-plus-admin/store/modules/enums";
import { items } from "element-plus-admin/store/modules/items";

export default { auth, enums, items };
